import PolipectomiaEndoscopicaIntestinoCrassoList from "./pages/PolipectomiaEndoscopicaIntestinoCrassoList.vue"
import PolipectomiaEndoscopicaIntestinoCrassoView from "./pages/PolipectomiaEndoscopicaIntestinoCrassoView.vue"
import PolipectomiaEndoscopicaIntestinoCrassoEdit from "./pages/PolipectomiaEndoscopicaIntestinoCrassoEdit.vue"

export default{
    PolipectomiaEndoscopicaIntestinoCrassoList,
    PolipectomiaEndoscopicaIntestinoCrassoView,
    PolipectomiaEndoscopicaIntestinoCrassoEdit
}
